import PropTypes from "prop-types";
import React from "react";
import NotificationItem from "./NotificationItem";

// Footer slot for GroupedVirtuoso. Reads page-load state from virtuoso's
// `context` prop (rather than closing over it) so the component identity
// stays stable across renders and the slot is never remounted between
// page loads.
//
// role="status" + aria-live="polite" announces each page load to screen
// readers without interrupting their current reading position.
const NotificationsLoadingFooter = ({ context }) =>
  context?.hasNextPage && context?.isNextPageLoading ? (
    <div role="status" aria-live="polite">
      <NotificationItem loadingSkeleton />
    </div>
  ) : null;

NotificationsLoadingFooter.propTypes = {
  context: PropTypes.shape({
    hasNextPage: PropTypes.bool,
    isNextPageLoading: PropTypes.bool,
  }),
};

export default NotificationsLoadingFooter;
